const extractIndexFromPath = (input) => {
  const regex = /^\[(\d+)]\.(.+)$/;
  const match = input.match(regex);

  if (!match) {
    throw new Error(
      `extractIndexFromPath failed to extract data from input ${input}`
    );
  }

  const index = parseInt(match[1], 10);
  const subpath = match[2];

  return [index, subpath];
};

export default extractIndexFromPath;
